import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EInternetStatus {
  Online = 'online',
  Offline = 'offline',
}

export type TInternetStatus = EInternetStatus.Online | EInternetStatus.Offline;

export enum EInternetStatusActionTypes {
  Set = 'internet-status/set',
}

export type TInternetStatusActions = ITypedReduxAction<EInternetStatusActionTypes.Set, TInternetStatus>;
